/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React from "react";
import AllReports from "../../../MiddleMileOperations/ExceptionReports/allReports";
const PinCodeActiveInactiveTimelineReports = () => {
    const embeddedId = "e48255de-0cb3-41ec-9ed3-c5f905a22346";
    const rsl = [];
    const title = "Pin Code Active/Inactive Timeline";
    return (
        <div>
            <AllReports embeddedId={embeddedId} rsl={rsl} title={title} />
        </div>
    );
};

export default PinCodeActiveInactiveTimelineReports;
